import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Connects to data-controller="spend-chart"
export default class extends Controller {
  static values = { series: Array }
  static targets = ["chart"]

  chart = null

  connect() {
    this.render()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  render() {
    const dates = this.seriesValue.map((d) => d.date)
    const spend = this.seriesValue.map((d) => d.spend)
    const installs = this.seriesValue.map((d) => d.installs)

    const options = {
      chart: { type: "line", height: 320, toolbar: { show: false }, zoom: { enabled: false } },
      stroke: { curve: "smooth", width: [3, 2] },
      colors: ["#71A2F6", "#4CAF50"],
      series: [
        { name: "Spend ($)", type: "area", data: spend },
        { name: "Installs", type: "line", data: installs },
      ],
      fill: { type: ["gradient", "solid"], gradient: { opacityFrom: 0.4, opacityTo: 0.05 } },
      dataLabels: { enabled: false },
      xaxis: { categories: dates, labels: { rotate: -45, style: { fontSize: "11px" } } },
      yaxis: [
        { title: { text: "Spend ($)" }, labels: { formatter: (v) => `$${v.toFixed(0)}` } },
        { opposite: true, title: { text: "Installs" }, labels: { formatter: (v) => v.toFixed(0) } },
      ],
      tooltip: { shared: true, x: { format: "yyyy-MM-dd" } },
      grid: { borderColor: "#f1f1f1" },
      legend: { position: "top" },
    }

    this.chart = new ApexCharts(this.chartTarget, options)
    this.chart.render()
  }
}
